<app-header></app-header>
<main class="main-content">
   <!------main-content------>
   <!-----------page_title--------------->
   <section class="page_title  pdt_80  pdb_40 min-height-auto" style="padding-bottom: 0px;">
      <div class="container">
         <div class="row">
            <!---------row----------->

            <!----------row-end---------->
         </div>
      </div>
   </section>
   <!-----------page_title-end-------------->
   <!-----------footer--------------->
   <section class="contact_page pdb_70 pdt_50">
      <div class="container">
         <div class="row">
            <!---------row----------->
            <div class="col-lg-6">
               <img src="assets/image/login.png" class="img-fluid">
            </div>

            <div class="col-lg-6 col-md-12">
               <!---------col----------->
               <div class="contact_us_form">
                  <div class="heading tp_one">

                     <h1 *ngIf="showLoginForm"> Login</h1>
                     <h1 *ngIf="showOtpForm"> Enter OTP</h1>

                  </div>

                  <!-- Login Form -->
                  <div *ngIf="showLoginForm"> 
                     <div class="form_box type_one remove-pt">


                        <form [formGroup]="loginForm" (ngSubmit)="onSubmit(loginForm.value)" autocomplete="off">
                           <div class="messages"></div>
                           <div class="controls">
                              <div class="row">

                                 <div class="col-lg-12">
                                    <div class="form-group">

                                       <select class="form-control select_input" formControlName="application_id"
                                          name="application_id"
                                          [ngClass]="{ 'is-invalid': submitted &amp;&amp; loginForm.controls.application_id.errors }">
                                          <option value="">Select Application Type</option>
                                          <option *ngFor="let app of applications" [value]="app.id">{{app.name}}
                                          </option>

                                       </select>


                                       <div *ngIf="submitted &amp;&amp; loginForm.controls.application_id.errors"
                                          class="form-text text-danger">
                                          <div *ngIf="loginForm.controls.application_id.errors.required">Application
                                             type is
                                             required</div>
                                       </div>

                                    </div>
                                 </div>

                                 <div class="col-lg-12">
                                    <div class="form-group">

                                       <input type="text" class="percent_100 login_input_padding"
                                          formControlName="emailAddress" name="emailAddress" placeholder="Email Address"
                                          [ngClass]="{ 'is-invalid': submitted &amp;&amp; loginForm.controls.emailAddress.errors }"
                                          [style.border-color]="submitted &amp;&amp; loginForm.controls.emailAddress.errors ?'#dc3545' : ''" />

                                       <div *ngIf="submitted &amp;&amp; loginForm.controls.emailAddress.errors"
                                          class="form-text text-danger">
                                          <div *ngIf="loginForm.controls.emailAddress.errors.required">Email is required
                                          </div>
                                          <div *ngIf="loginForm.controls.emailAddress.errors.pattern">Please enter a
                                             valid
                                             email</div>
                                          <div *ngIf="loginForm.controls.emailAddress.errors.maxlength">Email must be
                                             under
                                             45 characters</div>
                                       </div>
                                    </div>
                                 </div>




                                 <div class="col-lg-12">
                                    <div class="form-group relative-position">
                                       <input [type]="fieldTextType ? 'text' : 'password'"
                                          class="percent_100 login_input_padding" formControlName="password"
                                          name="password" placeholder="Password"
                                          [ngClass]="{ 'is-invalid': submitted &amp;&amp; loginForm.controls.password.errors }"
                                          [style.border-color]=" submitted &amp;&amp; loginForm.controls.password.errors ?'#dc3545' : ''" />

                                       <div class="input-group-append eye-password">
                                          <div class="input-group-text eye-position">
                                             <span class="fa" [ngClass]="{
                                                 'fa-eye': !fieldTextType,
                                                 'fa-eye-slash': fieldTextType
                                               }" (click)="toggleFieldTextType()">
                                             </span>
                                          </div>
                                       </div>

                                       <div *ngIf="submitted &amp;&amp; loginForm.controls.password.errors"
                                          class="form-text text-danger">
                                          <div *ngIf="loginForm.controls.password.errors.required">Password is required
                                          </div>
                                       </div>
                                    </div>
                                 </div>



                                 <div class="col-lg-12 mx-auto text-center">
                                    <div class="form-group">
                                       <button class="theme_btn tp_two" type="submit">Submit</button>
                                    </div>
                                 </div>
                                 <div class="col-lg-12 text-center flex-login">
                                    <input type="checkbox" class="input-checkbox"><label for="test2"
                                       class="font-12">Remember me
                                    </label> &nbsp; &nbsp; | &nbsp; &nbsp;
                                    <a [routerLink]="['/forgot']" class="form-text mt-3 text-muted">Forgot Password</a>


                                 </div>


                              </div>

                           </div>
                        </form>
                     </div>
                  </div>
                  <!-- Login Form - End -->



                  <!-- Enter Token -->
                  <div *ngIf="showOtpForm"> 
                     <div class="form_box type_one remove-pt">
                        <div class="" *ngIf="showOtpForm">
                           <form [formGroup]="otpForm" (ngSubmit)="onOtpSubmit(otpForm.value)" autocomplete="off">
                              <div class="messages"></div>
                              <div class="controls">
                                 <div class="row">
                                    <div class="col-lg-12">
                                       <div class="form-group relative-position">

                                          <input [type]="fieldTextType2 ? 'text' : 'password'"
                                             class="percent_100 login_input_padding" formControlName="enterOtp"
                                             name="enterOtp" placeholder="Enter OTP"
                                             [ngClass]="{ 'is-invalid': submitted &amp;&amp; otpForm.controls.enterOtp.errors }"
                                             [style.border-color]="submitted &amp;&amp; otpForm.controls.enterOtp.errors ?'#dc3545' : ''" />

                                          <div class="input-group-append eye-password">
                                             <div class="input-group-text eye-position">
                                                <span class="fa" [ngClass]="{
                                                 'fa-eye': !fieldTextType2,
                                                 'fa-eye-slash': fieldTextType2
                                               }" (click)="toggleFieldTextType2()">
                                                </span>
                                             </div>
                                          </div>

                                          <div *ngIf="submitted &amp;&amp; otpForm.controls.enterOtp.errors"
                                             class="form-text text-danger">
                                             <div *ngIf="otpForm.controls.enterOtp.errors.required">OTP is required
                                             </div>
                                          </div>
                                       </div>

                                       <!-- <div class="col-lg-12 text-center">
                                       <div class="form-group ">
                                          <button class="submit_btn " type="submit">Submit</button><br><br>
                                          <a [routerLink]="['/login']" class="link-back-to-login">Back to Login</a>
                                       </div>
                                    </div> -->
                                       <div class="col-lg-12 mx-auto text-center">
                                          <div class="form-group">
                                             <button class="theme_btn tp_two white-text " type="submit">Submit</button>
                                          </div>
                                       </div>

                                       <div class="col-lg-12 text-center flex-login">

                                          <a (click)="backToLogin()" class="form-text mt-3 a_link">Back to Login</a>
                                          &nbsp; &nbsp; | &nbsp; &nbsp;
                                          <a (click)="requestNewOtp()" class="form-text mt-3 a_link">Resend OTP</a>
                                       </div>


                                    </div>
                                 </div>
                              </div>

                           </form>
                        </div>
                     </div>
                  </div>
                  <!-- Enter Token - End -->

               </div>
            </div>

            <!---------col-end---------->
         </div>

         <!-- <div class="" *ngIf="!showOtpForm">
            <div class="heading tp_one">

               <h1> Login</h1>

            </div>

            <div class="form_box type_one remove-pt">
               <form [formGroup]="otpForm" (ngSubmit)="onOtpSubmit(otpForm.value)">
                  <div class="messages"></div>
                  <div class="controls">
                     <div class="row">
                        <div class="col-lg-12">
                           <div class="form-group">
                              <input type="text" class="ptbs-30" formControlName="enterOtp" name="enterOtp"
                                 placeholder="Enter OTP"
                                 [ngClass]="{ 'is-invalid': submitted &amp;&amp; otpForm.controls.enterOtp.errors }" />
                              <small class="linearicons-lock top_a_23"></small>
                              <div *ngIf="submitted &amp;&amp; otpForm.controls.enterOtp.errors"
                                 class="form-text text-danger">
                                 <div *ngIf="otpForm.controls.enterOtp.errors.required">OTP is required</div>
                              </div>
                           </div>
                        </div>

                     </div>

                     <div class="col-lg-10">
                        <div class="form-group row">
                           <button class="submit_btn " type="submit">Submit</button>
                           <a (click)="backToLogin()" class="form-text mt-3 ml-5 text-muted">Back to Login</a>
                           <a (click)="requestNewOtp()" class="form-text mt-3 ml-5 text-primary">Request New OTP</a>
                        </div>
                     </div>



                     <div class="col-lg-6 text-center">
                        <div class="form-group mg_top check_box">
                           <input name="checkbox" type="checkbox" id="test2" required="required">
                        </div>
                     </div>
                  </div>
               </form>
            </div>
         </div> -->

      </div>
   </section>
   <app-footer></app-footer>

</main>
<app-scrolltotop></app-scrolltotop>